import { Component, OnInit, ViewEncapsulation, ElementRef, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import merkle_mb_stage1 from './merkle-mb-stage1.json';
//import * as merkle_mb_stage2 from './merkle-mb-stage2.json';
import { Router } from '@angular/router'
import { fetchJson } from '@ethersproject/web';
import { BigNumber, utils } from 'ethers';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { switchMap, takeWhile, timer } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { ONRAMPER_QUERY_PARAM, convertJSONToQueryParam } from 'app/common/components/onramper/onramper.config';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import * as abi from "app/services/abi/index"
import { MerkleMBService } from 'app/services/contract/contracts-services/merkleMB.service';
import { environment } from 'environments/environment';
import { PancakeV2Service } from 'app/services/contract/contracts-services/pancake.service';
import { ContractsService } from 'app/services/contract/contracts.service';
import { eContracts } from 'app/services/contract/contract.config';
import { IDropdownButtonItem } from 'app/common/ui/k-dropdown-button/k-dropdown-button.interface';
import { ICompanyItemsResponse, companyItemImgPath } from 'app/services/companyItems/company-items.interface';
import { currencyImgPath, eCurrencies } from 'app/common/ui/info-icon/info-icon.interface';
// import { StripeService } from 'app/services/stripe/stripe.service'


declare const tsParticles;
declare const Simplex;
declare const analytics;
const isEmpty = (obj) => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key))
      return true;
  }
  return false;
}

interface httpResult {
  status
  data
  description
}

interface Kryptomons {
  image
  type
  talent
  typeFormatted
  xfactor
  speciality
  timeBorn
  super
  personality
  generation
  id
  islandImage
  timeBornUnix
  unfreezable
  bio
}

interface Personality {
  Constitution
  Affection
  Crazyness
  Instinct
  Hunger
  Laziness
  Braveness
  Smart
  Ego
  generation
}


@Component({
  selector: 'app-mb-sale',
  templateUrl: './mb-sale.component.html',
  styleUrls: ['./mb-sale.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MbSaleComponent implements OnInit {


  public connection_text
  public noWallet
  public accounts
  public disabled
  public whitelisted
  public soldOut
  public claimed
  public claims
  public listedOnDb
  public notListed
  public showShare
  public modalImage
  public modalTitle
  public modalContent
  public modalCta
  public isLoadingBuy
  public actionTodo
  public kryptomons
  public typeFormatted = ["Fire", "Water", "Ice", "Ground", "Air", "Electro", "Ghost", "Grass"];
  public collectedKryptomon
  public isClosed
  public airdropClaim
  public availableRewards = []
  public availableCryptoComClaims = []
  public sales = null;
  public maxSalesAvailable;
  public mbSold;
  public purchaseTokenBalance;
  public purchaseTokenName;
  public prices;
  public authorized;
  public isLoadingAuthorize;
  public ended;
  public utils;
  public account
  public salesInternal;
  public canBuyKmon;
  public bnbBalance;
  public bnbToUsd;
  public kmonToUsd;
  public kmonToBnb;
  public requiredBNBBalance;
  public kmonOutstanding;
  public totalAmounts
  public showWidget
  public bnbBalanceInit
  public waitingForFunds
  public isLonger
  public paymentMethod
  public parsedBoxes
  public purchaseBoxes: any = []
  public boxSelected: any = [false, false, false, false]
  public isSimplexLoading: any = [false, false, false, false]
  public isSimplexSuccess: any = [false, false, false, false]
  public amountSelected
  public kmonAmountSelected
  public simulateSuccess
  public isLoading
  public purchasesPerUserPerSale
  showOnramper: boolean = false;
  onramperQueryParam: { [key: string]: string } = ONRAMPER_QUERY_PARAM();
  onramperQUeryParamString: string;
  srcOnramper: SafeResourceUrl;
  partnerContext: string;
  indexCard: number;
  bnbAmountToConvert: number;
  wallet: string;
  contractMBPurchaseToken: any;
  babyDogeBalance:any;
  babyDogeContract:any;
  buyMethods: IDropdownButtonItem[] = [];
  itemData: any
  showStripeModal:boolean = false
  purchaseContext:any
  canClaimCosmetic
  forceClosed: boolean = false;

  constructor(
    public http: HttpClient,
    public router: Router,
    private sanitizer: DomSanitizer,
    private eRef: ElementRef,
    private toastService: ToastService,
    private userService: UserService,
    private web3Service: Web3Service,
    private merkleMBService: MerkleMBService,
    private contractsService: ContractsService,
    private pancakeV2Service: PancakeV2Service,
    // private stripeService: StripeService
  ) {

    this.disabled = [true, true, true]
    this.soldOut = [false, false, false]
    this.claimed = [false, false, false];
    this.claims = {};
    this.whitelisted = [true, true, true];
    this.notListed = false;
    this.showShare = false;
    this.isLoadingBuy = false;
    this.kryptomons = []
    this.collectedKryptomon = false;
    this.isClosed = false;
    this.airdropClaim = null;
    this.authorized = true;
    this.ended = false;
    this.isLoadingAuthorize = false;
    this.utils = utils;
    this.prices = [0];
    this.canBuyKmon = false;
    this.showWidget = false;
    this.bnbBalance = "0";
    this.waitingForFunds = false;
    this.isLonger = false;
    this.simulateSuccess = false;
    this.salesInternal = [
      { id: 0, image: 'babydoge_head.png', name: "Babydoge Head", price:  9.99},
      { id: 1, image: 'santa_red.jpg', name: 'Full RED santa suit (with santa hat)', price:  24.99}
    ]
    // this.salesInternal = [
    //   { id: 0, image: 'd48a2f38-fac5-4d28-acda-8931b0c899fd.png', name: 'Turkey Trainer Bundle' },
    //   { id: 1, image: 'b2fe4dc8-7ab3-4d13-9863-fc2d47edefbc.png', name: 'USA Trainer Bundle' },
    //   { id: 2, image: 'e582cb9c-64c8-4e19-a611-8467afd387a5.png', name: 'Thailand Trainer Bundle' },
    //   { id: 3, image: 'c1dec2a5-4693-46c9-a578-8f53990515be.png', name: 'Italy Trainer Bundle' },
    //   { id: 4, image: 'b8e6180e-eae7-4a32-b62f-8becacec56b0.png', name: 'Japan Trainer Bundle' },
    //   { id: 5, image: '1dd035b6-0ff5-4207-8ee9-b67e26c887f7.png', name: 'India Trainer Bundle' },
    //   { id: 6, image: '53fee1ee-207a-4a37-ab8a-b361eb95be62.png', name: 'Indonesia Trainer Bundle' },
    //   { id: 7, image: '997314a0-2d73-47ca-85eb-f9ee4d57378b.png', name: 'Spain Trainer Bundle' },
    //   { id: 8, image: 'b7feb945-6f0a-487c-949a-bdb2a08d6166.png', name: 'Germany Trainer Bundle' },
    //   { id: 9, image: '84eb122e-3b06-4b10-8092-aaa12c96bea9.png', name: 'Brazil Trainer Bundle' },
    //   { id: 10, image: '223941a5-41f8-4c8f-978a-35971d6519e4.png', name: 'Phillipines Trainer Bundle' },
    //   { id: 11, image: 'e63ecda4-9cdb-4bfa-850a-7c27d21de65f.png', name: 'Netherland Trainer Bundle' },
    // ]
    this.purchasesPerUserPerSale = {};

    // if (this.appComponent.accounts == undefined) {
    //   this.appComponent.accountsObservable.subscribe((item: any) => {
    //     this.wallet = item[0];
    //     this.noWallet = false;
    //     if (this.wallet !== undefined && this.wallet !== "") {
    //       this.init();
    //     }
    //   });
    // } else {
    //   this.wallet = this.appComponent.accounts[0];
    //   this.noWallet = false;
    //   this.init();
    // }
    this.wallet = this.userService._userInfoData.recordedWallet;
    this.init();

    //this.checkClose()
  }

  ngOnInit(): void {

  }

  async init() {
    this.sales = await this.merkleMBService.contract.methods.getSaleInfos().call();
    console.log(this.utils);
    const purchaseToken = await this.merkleMBService.contract.methods.paymentToken().call();
    this.contractMBPurchaseToken = await new (this.web3Service.getWeb3()).eth.Contract(abi.tokenAbiJson, purchaseToken);
    this.babyDogeContract = await new (this.web3Service.getWeb3()).eth.Contract(abi.BabyDogeAbi, "0xc748673057861a797275CD8A068AbB95A902e8de");
    console.log(this.babyDogeContract)
    const utils = this.web3Service.getWeb3().utils;
    this.purchaseTokenName = await this.contractMBPurchaseToken.methods.name().call();
    console.log(this.purchaseTokenName)
    const allowance = await this.contractMBPurchaseToken.methods.allowance(this.wallet, this.merkleMBService.contract._address).call();
    this.authorized = parseInt(allowance) >= parseInt(utils.toWei('9999999999'));
    const balanceBnb = await this.web3Service.getWeb3().eth.getBalance(this.wallet);
    this.bnbBalanceInit = await parseFloat(this.web3Service.getWeb3().utils.fromWei(balanceBnb))
    /*this.http.get("https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
      console.log(item)
      let kmonPrice = item.kryptomon.usd;
      let bnbAmount = 5 / item.wbnb.usd;
      this.createBuyingBoxesRefill(kmonPrice, bnbAmount)
    })*/
    this.refresh();
    setInterval(() => {
      this.refresh();
    }, 5000)

    // this.sales = await this.merkleMBService.contract.methods.getSaleInfos().call();
    this.prices = this.sales.map((sale) => sale.price);
    console.log(this.prices)
    let res = await fetchJson("https://api.binance.us/api/v3/ticker/price?symbol=BNBBUSD");
    this.bnbToUsd = BigNumber.from(utils.toWei(res.price));
    //res = await fetchJson("https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18");
    //this.kmonToUsd = BigNumber.from(utils.toWei(res.kryptomon.usd.toString()));
    //this.kmonToBnb = BigNumber.from(utils.toWei(res.kryptomon.bnb.toString()));
    //this.bnbToUsd = BigNumber.from(utils.toWei(res.wbnb.usd.toString()));
    //this.totalAmounts = this.prices.map((price) => utils.fromWei(price.toString()) * res.kryptomon.usd);
    console.log(this.totalAmounts)
    this.itemData = {prices:[{currency:{symbol:this.purchaseTokenName}},{currency:{symbol:"BabyDoge"}},{currency:{symbol:"USD"}}]}
    console.log(this.itemData)
    this.buyMethods = BUY_METHODS(this.itemData);
    console.log(this.buyMethods)
  }

  refresh() {
    this.updateSales();
    this.checkClaim(0);
    this.updateBalances();
    if(this.canClaimCosmetic == undefined){
      this.checkCosmetic();
    }
    // this.checkClaim(1);
    // this.checkClaim(2);
  }

  async updateBalances() {
    const utils = this.web3Service.getWeb3().utils;
    this.purchaseTokenBalance = await this.contractMBPurchaseToken.methods.balanceOf(this.wallet).call();
    console.log(await this.babyDogeContract.methods.balanceOf(this.wallet).call())
    let babyDogeBalance = await this.babyDogeContract.methods.balanceOf(this.wallet).call();
    this.babyDogeBalance = await parseFloat(this.web3Service.getWeb3().utils.fromWei(babyDogeBalance))*1000000000
    console.log(this.babyDogeBalance)
    this.bnbBalance = BigNumber.from(await this.web3Service.getWeb3().eth.getBalance(this.wallet));
    this.kmonOutstanding = BigNumber.from(this.purchaseTokenBalance).sub(BigNumber.from(this.prices[this.prices.length - 1]));
    console.log(this.kmonOutstanding);
    if (this.kmonOutstanding.isNegative()) {
      this.kmonOutstanding = this.kmonOutstanding.abs();
      if (this.bnbBalance > 0) {
        // calculate required BNB for the KMON purchase
        this.requiredBNBBalance = this.kmonOutstanding.mul(this.kmonToBnb).div(utils.toWei("1")).mul(utils.toWei("1.05")).div(utils.toWei("1"));
        if (this.requiredBNBBalance.lt(this.bnbBalance)) {
          this.canBuyKmon = true;
        }
      }
    }
  }

  async updateSales() {
    const utils = this.web3Service.getWeb3().utils;
    this.sales = await this.merkleMBService.contract.methods.getSaleInfos().call();
    //this.getDisabledMessage(this.sales)
    this.maxSalesAvailable = await this.merkleMBService.contract.methods.maxSales().call();
    this.mbSold = await this.merkleMBService.contract.methods.mbPurchased().call();
    this.updateUserPurchases();
  }

  async updateUserPurchases() {
    for (let i = 0; i < this.sales.length; i++) {
      this.purchasesPerUserPerSale[i] = await this.merkleMBService.contract.methods.getUserPurchaseCount(this.wallet, i).call();
    }
  }

  async checkClaim(stage) {
    let claim;

    return;

    if (stage == 0) {
      claim = merkle_mb_stage1.claims[this.web3Service.getWeb3().utils.toChecksumAddress(this.wallet)];
      if (claim) {
        claim.account = this.wallet;
        this.claims[stage] = claim;
        this.whitelisted[stage] = true;
      }
    }
    else if (stage == 1) {
      try {
        claim = await fetchJson(environment.apiBaseUrlV22 + 'airdrop/' + this.wallet);
      }
      catch {

      }
      if (claim) {
        claim.account = claim.address;
        this.claims[stage] = claim;
        this.whitelisted[stage] = true;
      }
    }
    else {
      return;
    }

    if (claim == undefined) {
      this.disabled[stage] = true;
      this.whitelisted[stage] = false;
    } else {
      // check if the claim has been completed
      let isClaimed = false;
      if (claim != undefined)
        isClaimed = await this.isClaimed(claim, this.merkleMBService.contract, stage);

      if (isClaimed) {
        this.claimed[stage] = true;
      }
      else {
        this.claimed[stage] = false;
      }
    }

  }

  async isClaimed(claim, merkleInstance, stage) {
    return await merkleInstance.methods.isClaimed(claim.index, stage).call();
  }

  async getClaim() {
    try {
      this.airdropClaim = await fetchJson(environment.apiBaseUrlV22 + 'airdrop/' + this.wallet);
    }
    catch {
      this.airdropClaim = undefined;
    }
  }

  closeSimplex() {
    Simplex.unload();
    this.showWidget = false;
    this.isLoadingBuy = false;
    this.isSimplexLoading = [false, false, false];
  }

  buyGate(event, stage){
    console.log(event)
    console.log(stage)
    if(event.id=="USD"){
      this.purchaseContext = {
        userEmail: this.userService._userInfoData.loginEmail,
        walletId: this.userService._userInfoData.recordedWallet,
        indexSale: stage,
        contractAddress: this.contractsService.getContract(eContracts.MerkleMB)._address,
        reason:'sale'
      }
      console.log(this.purchaseContext)
      this.showStripeModal = true;
    }else{
      this.authorizePaymentToken(stage, event.id);
    }
  }
  async buy(stage) {
    this.isLoadingBuy = true;
    analytics.track('ArmourSale', { section: 'trainerHub', value: this.wallet, status: 'started', paymentMethod: '' })
    if (BigNumber.from(this.purchaseTokenBalance).lt(BigNumber.from(this.prices[stage]))) {
      if (this.canBuyKmon) {
        let expiry = Math.floor(Date.now() / 1000) + 60 * 10;
        let expireWei = this.web3Service.getWeb3().utils.toWei(expiry.toString());
        let path = ["0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", "0xc732B6586A93b6B7CF5FeD3470808Bc74998224D"]
        await this.pancakeV2Service.contract.methods.swapExactETHForTokens(this.kmonOutstanding, path, this.wallet, expireWei).send({
          ...this.contractsService.additionalParameters(),
          from: this.wallet,
          value: this.requiredBNBBalance
        }).then((item) => {
          if (item.status) {
            this.updateBalances().then(() => {
              this.paymentMethod = "BNB"
              //this.buyMysteryBox(stage);
            })

          } else {
            this.toastService.genericError();
          }
        }).catch((err) => {
          this.toastService.genericError();
        })

      }
      else {
        // initiate Simplex transaction for the BNB topup
        //this.startPurchase(stage);
        console.log('simplex');
        this.toastService.add(
          {
            severity: 'error',
            summary: 'errorMsg.generic',
            detail: 'errorMsg.notEnoughKMONorBNB',
          }
        )
        this.isLoadingBuy = false;
      }
    } else {
      this.paymentMethod = "KMON"
      //this.authorizePaymentToken(stage);
    }
  }

  startPurchase(stage) {
    this.paymentMethod = "CreditCard"
    if (this.totalAmounts[stage] <= 5) {
      this.totalAmounts[stage] = 5;
    }
    this.isLoadingBuy = true;
    let post = { walletId: this.wallet, amount: this.totalAmounts[stage] }
    console.log(post)
    this.http.post("https://api.kryptomon.co/simplex/makePurchase.php", post).subscribe((item: any) => {
      console.log(item)

      if (item.status == "done") {
        this.showWidget = true;
        const params = {
          payment_id: item.payload.paymentId
        }

        Simplex.load(params, (event) => {

          Simplex.subscribe('onlineFlowFinished', (event) => {
            if (event.payload.result == "success") {
              //this.isLoadingBuy = false;
              this.checkBnbPurchase(0, stage)
            } else {
              this.isLoadingBuy = false;
              console.log('ops something went wrong')
              this.toastService.genericError();
            }
          })
        })
      } else {
        this.isLoadingBuy = false;
        this.toastService.genericError();
      }
    })
  }

  paypalCallback(event){
    console.log(event)
    if(event){
      this.toastService.add({
            severity: 'success',
            summary: 'shared.success',
            detail: 'toastMessage.purchasedItem',
          });
    }else{
      this.toastService.genericError()
    }
  }
  async checkBnbPurchase(timer, stage) {
    Simplex.unload();
    this.waitingForFunds = true;

    const balanceBnb = await this.web3Service.getWeb3().eth.getBalance(this.wallet);
    let newBnbBalance = await parseFloat(this.web3Service.getWeb3().utils.fromWei(balanceBnb))
    if (newBnbBalance > this.bnbBalanceInit) {
      this.buy(stage);
    } else {
      if (timer == 60) {
        this.isLonger = true;
      } else {
        setTimeout(() => {
          timer = timer + 1;
          this.checkBnbPurchase(timer, stage);
        }, 5000)
      }
    }

  }

  async buyMysteryBox(stage, selectedContract) {
    //if (this.isLoadingBuy)
    //return;

    if (this.getDisabledMessage(stage) != "")
      return;

    this.isLoadingBuy = true;
    const buyClaim = this.claims[stage];

    if (buyClaim !== undefined && stage < 2) {
      this.processBuyClaim(buyClaim, selectedContract, stage);
    }
    else {
      this.processBuyClaim({ index: 0, account: this.wallet, proof: [] }, selectedContract, stage);
    }
  }

  async authorizePaymentToken(stage, paymentCurrency) {
    this.isLoadingBuy = true;

    let contractIndex = this.itemData.prices.findIndex(x => x.currency.symbol == paymentCurrency);
    console.log(contractIndex)
    if(contractIndex==0){
        var selectedContract = this.merkleMBService.contract
        
    }else{
        var selectedContract = this.merkleMBService.contractTwo
    }

    const utils = this.web3Service.getWeb3().utils;

    const purchaseToken = await selectedContract.methods.paymentToken().call();
    this.contractMBPurchaseToken = await new (this.web3Service.getWeb3()).eth.Contract(abi.tokenAbiJson, purchaseToken);

    const allowance = await this.contractMBPurchaseToken.methods.allowance(this.wallet, selectedContract._address).call();
    this.authorized = parseInt(allowance) >= parseInt(utils.toWei('9999999999'));

    if (this.authorized) {
      this.buyMysteryBox(stage, selectedContract);
    } else {
      //this.isLoadingAuthorize = true;
      this.contractMBPurchaseToken.methods.approve(selectedContract._address, this.web3Service.getWeb3().utils.toWei('999999999999')).send({
        ...this.contractsService.additionalParameters(),
        from: this.wallet
      }).then((result) => {
        this.authorized = true;
        this.buyMysteryBox(stage, selectedContract);
      }).catch((err) => {
        this.toastService.genericError();
        this.isLoadingBuy = false;
      })
    }
  }

  async processBuyClaim(claim, contractMerkleInstance, stage) {
    if (claim !== undefined) {
      let allowance = await this.contractMBPurchaseToken.methods.allowance(this.wallet, contractMerkleInstance._address).call();
      if (allowance >= this.prices[stage]) {
        this.executeClaim(claim, contractMerkleInstance, stage);
      }
      else {
        this.contractMBPurchaseToken.methods.approve(contractMerkleInstance._address, this.web3Service.getWeb3().utils.toWei('999999999999')).send({
          ...this.contractsService.additionalParameters(),
          from: this.wallet
        }).then((result) => {
          if (result.events.Approval !== undefined) {
            this.authorized = true;
            this.executeClaim(claim, contractMerkleInstance, stage);
          } else {
            this.isLoadingBuy = false;
          }
        }, (error) => {
          //console.log(error)
          this.isLoadingBuy = false;
        })
      }
    } else {
      //console.log('notlisted')
      this.isLoadingBuy = false;
      this.notListed = true;
    }
  }

  createBuyingBoxesRefill(kmonPrice, bnbAmount) {

    for (let i = 0; i < 4; i++) {
      let purchaseBox: any = {}
      purchaseBox.img = "./assets/img/Icon/coins_" + i + ".png";
      purchaseBox.totalValue = Math.round((19.99 + (i * 20)) * 100) / 100;
      console.log(purchaseBox.totalValue)
      purchaseBox.kmonAmount = (Math.round((purchaseBox.totalValue - 5) / kmonPrice * 100) / 100)
      purchaseBox.bnbAmount = (Math.round(bnbAmount * 100) / 100)
      if (purchaseBox.kmonAmount >= 1000) {
        purchaseBox.kmonAmountFormatted = (Math.round(purchaseBox.kmonAmount / 1000 * 100) / 100).toLocaleString() + "K"
      } else {
        purchaseBox.kmonAmountFormatted = (Math.round(purchaseBox.kmonAmount * 100) / 100).toLocaleString()
      }

      this.purchaseBoxes.push(purchaseBox);
    }
    this.boxSelected[0] = false;
    this.parsedBoxes = false;
    //this.amountSelected = this.purchaseBoxes[0].totalValue
    console.log(this.purchaseBoxes)
  }

  initPurchase(index) {
    if (this.wallet) {
      this.partnerContext = uuidv4();
      this.indexCard = index;
      this.isSimplexLoading = [false, false, false, false]
      this.isSimplexSuccess = [false, false, false, false]
      for (let i = 0; i < 4; i++) {
        if (i == index) {
          this.isSimplexLoading[i] = true;
          this.amountSelected = this.purchaseBoxes[i].totalValue
          this.kmonAmountSelected = this.purchaseBoxes[i].kmonAmount
          this.http.get("https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
            console.log(item);
            let bnbAmount = (this.amountSelected - 5) / item.wbnb.usd * 1.05;
            this.bnbAmountToConvert = bnbAmount;
            console.log(bnbAmount)
            console.log(this.bnbBalanceInit)
            if (this.bnbBalanceInit * 1.10 > bnbAmount) {
              this.checkAllowance(bnbAmount, i)
            } else {
              this.startPurchaseRefill(i)
            }

          })
          //
        } else {
          this.isSimplexLoading[i] = false;
        }
      }
      console.log(this.boxSelected)
    }
  }

  getSrcOnramper() {
    // this.onramperQueryParam['defaultAmount'] = '';
    this.onramperQueryParam['defaultAmount'] = this.amountSelected;
    this.onramperQueryParam['networkWallets'] = ONRAMPER_QUERY_PARAM()['networkWallets'];
    this.onramperQueryParam['networkWallets'] += this.wallet;
    this.onramperQueryParam['partnerContext'] = this.partnerContext;
    // console.log(this.onramperQueryParam);
    this.onramperQUeryParamString = convertJSONToQueryParam(this.onramperQueryParam);
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://buy.onramper.com/?' + this.onramperQUeryParamString
    );
  }
  closeOnramper() {
    this.showOnramper = false;
    this.isSimplexLoading = [false, false, false];
    this.checkOnramperTransactionStatus();
  }

  checkOnramperTransactionStatus() {
    const maxAttempts = 20;
    const interval = 6000; // 6 seconds
    let attempts = 0;
    this.isSimplexLoading[this.indexCard] = true;
    timer(0, interval)
      .pipe(
        takeWhile(() => attempts < maxAttempts),
        // https://api-staging-n7ni4.ondigitalocean.app/onramper/status/
        // switchMap(() => this.http.get<any>('http://localhost:5530/onramper/status/' + this.partnerContext))
        switchMap(() => this.http.get<any>('https://stingray-app-4qz4a.ondigitalocean.app/onramper/status/' + this.partnerContext))
      )
      .subscribe(
        response => {
          if (response.status === 'completed') {
            console.log('attempts: ' + attempts);
            //Convert directly
            this.convertBNBtoKMONRefill(this.bnbAmountToConvert, this.indexCard);
            this.isSimplexLoading[this.indexCard] = false;
            attempts = maxAttempts;
          } else if (response.status === 'pending') {
            attempts++;
            console.log(`Attempt ${attempts} - answer: ${response.status}`);
            this.isSimplexLoading[this.indexCard] = true;
          } else {
            this.toastService.genericError();;
            this.isSimplexLoading[this.indexCard] = false;
          }
        },
        error => {
          if (error.status === 404) console.error('Transaction not executed:', error);
          this.isSimplexLoading[this.indexCard] = false;
        }
      );
  }

  startPurchaseRefill(index) {
    this.isSimplexLoading[index] = true;
    let post = { walletId: this.wallet, amount: this.amountSelected }
    console.log(post);
    this.srcOnramper = this.getSrcOnramper();
    this.showOnramper = true;
    // this.http.post("https://api.kryptomon.co/simplex/makePurchase.php", post).subscribe((item: any) => {
    //   console.log(item)

    //   if (item.status == "done") {
    //     this.showWidget = true;
    //     const params = {
    //       payment_id: item.payload.paymentId
    //     }

    //     Simplex.load(params, (event) => {

    //       Simplex.subscribe('onlineFlowFinished', (event) => {
    //         this.showWidget = false;
    //         if (event.payload.result == "success") {
    //           this.checkBnbPurchase(index, 0)
    //           /* setTimeout(()=>{
    //                this.simulateSuccess = false
    //            },10000)*/
    //         } else {
    //           Simplex.unload();
    //           this.isSimplexLoading[index] = false;
    //           console.log('ops something went wrong')
    //           this.toastService.genericError();
    //         }
    //       })
    //     })
    //   } else {
    //     this.isSimplexLoading[index] = false;
    //     this.toastService.genericError();
    //   }
    // })
  }
  async checkBnbPurchaseRefill(index, timer) {
    Simplex.unload();
    const balanceBnb = await this.web3Service.getWeb3().eth.getBalance(this.wallet);
    let newBnbBalance = await parseFloat(this.web3Service.getWeb3().utils.fromWei(balanceBnb))
    console.log(newBnbBalance)
    if (newBnbBalance > this.bnbBalanceInit || this.simulateSuccess) {
      let bnbReceived = newBnbBalance - this.bnbBalanceInit;
      this.http.get("https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
        let amountToConvert = bnbReceived - Math.round(5 / item.wbnb.usd * 100) / 100
        console.log(amountToConvert)
        this.checkAllowance(amountToConvert, index)
      })
    } else {
      if (timer == 60) {
        this.isLonger = true;
      } else {
        setTimeout(() => {
          timer = timer + 1;
          this.checkBnbPurchase(index, timer);
        }, 5000)
      }
    }

  }

  async convertBNBtoKMONRefill(bnbAmount, index) {

    this.http.get("https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
      let minKmonAmount = bnbAmount / item.kryptomon.bnb * 0.80;
      let bnbAmountWei = this.web3Service.getWeb3().utils.toWei(bnbAmount.toString());
      let minKmonAmountWei = this.web3Service.getWeb3().utils.toWei(minKmonAmount.toString());
      let path = ["0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", "0xc732B6586A93b6B7CF5FeD3470808Bc74998224D"]
      let expiry = Math.floor(Date.now() / 1000) + 60 * 10;
      let expireWei = this.web3Service.getWeb3().utils.toWei(expiry.toString());
      console.log(expireWei)
      this.pancakeV2Service.contract.methods.swapExactETHForTokens(minKmonAmountWei, path, this.wallet, expireWei).send({
        ...this.contractsService.additionalParameters(),
        from: this.wallet,
        value: bnbAmountWei
      }).then((item) => {
        if (item.status) {
          this.isSimplexLoading[index] = false;
          this.isSimplexSuccess[index] = true;
          this.updateBalances();
          //this.getWalletTransactions()
          //this.getKmonBalance()
          //this.getBnbBalance()
          setTimeout(() => {
            this.isSimplexSuccess[index] = false;
          }, 5000)
        } else {
          this.isSimplexLoading[index] = false;
          this.toastService.genericError();
        }
      }).catch((err) => {
        this.isLoading = false;
        this.isSimplexLoading[index] = false;
        this.toastService.genericError();
      })
    }, (err) => {
      this.isLoading = false;
      this.isSimplexLoading[index] = false;
      this.toastService.genericError();
    })

  }

  async checkAllowance(amountToConvert, index) {
    let allowance = await this.contractsService.getContract(eContracts.WBNB).methods.allowance(this.wallet, "0x10ED43C718714eb63d5aA57B78B54704E256024E").call();
    let hasAllowance = BigNumber.from(allowance).gt(0);

    if (hasAllowance) {
      this.convertBNBtoKMONRefill(amountToConvert, index)
    } else {
      this.contractsService.getContract(eContracts.WBNB).methods.approve("0x10ED43C718714eb63d5aA57B78B54704E256024E", this.web3Service.getWeb3().utils.toWei('999999999999')).send({
        ...this.contractsService.additionalParameters(),
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Approval !== undefined) {
          this.convertBNBtoKMONRefill(amountToConvert, index)
        } else {
          this.isSimplexLoading[index] = false;
          this.toastService.genericError();
        }
      }).catch((err) => {
        this.isSimplexLoading[index] = false;
        this.toastService.genericError();
        console.log('allowance failed')
      });;
    }
  }

  getDisabledMessage(stage) {
    if (this.sales) {

      const sale = this.sales[stage];

      if (sale === undefined) {
        return 'Wrong sale';
      }

      if (parseInt(this.mbSold) >= parseInt(this.maxSalesAvailable)) {
        this.ended = true;
        return "Sold out!";
      }

      if (sale.maxSales > 0) {
        if (parseInt(sale.saleCount) >= parseInt(sale.maxSales)) {
          return "Sold out!";
        }
      }

      if (this.getDateFromEpoch(sale.endTime) < new Date()) {
        if (stage == 0) {
          this.ended = true;
        }
        return "Sale ended";
      }

      if (this.claimed[stage]) {
        return "Already claimed";
      }

      // if (!this.whitelisted[stage]) {
      //   return "You're not whitelisted"
      // }

      if (this.getDateFromEpoch(sale.startTime) > new Date()) {
        return "Starting at " + this.getDateFromEpoch(sale.startTime, true).toLocaleString();
      }

     /* if (BigNumber.from(this.purchaseTokenBalance).lt(BigNumber.from(this.prices[stage]))) {
        return "Not enough " + this.purchaseTokenName;
      }*/
      if (sale.maxSalesPerUser > 0 && parseInt(this.purchasesPerUserPerSale[stage]) >= sale.maxSalesPerUser) {
        return "Max purchase limit reached";
      }

      if (this.getDateFromEpoch(sale.endTime) > new Date() && this.getDateFromEpoch(sale.startTime) < new Date()) {
        // ongoing sale
        // check if claimed
        // check if sold out

      }

      return "";
    } else return "";
  }

  getDateFromEpoch(epochString, forDisplay = false) {
    let dateInUnix = parseInt(epochString);
    if (forDisplay)
      return new Date((dateInUnix) * 1000);
    else
      return new Date((dateInUnix + 10) * 1000);
  }

  async processClaim(claim, contractMerkleInstance, stage) {
    if (claim !== undefined) {
      let allowance = await this.contractsService.getContract(eContracts.KMON).methods.allowance(this.wallet, contractMerkleInstance._address).call();
      if (allowance > 0) {
        this.executeClaim(claim, contractMerkleInstance, stage);
      }
      else {
        this.contractsService.getContract(eContracts.KMON).methods.approve(contractMerkleInstance._address, this.web3Service.getWeb3().utils.toWei('999999999999')).send({
          ...this.contractsService.additionalParameters(),
          from: this.wallet
        }).then((result) => {
          if (result.events.Approval !== undefined) {
            this.executeClaim(claim, contractMerkleInstance, stage);
          } else {
            this.isLoadingBuy = false;
          }
        }, (error) => {
          //console.log(error)
          this.isLoadingBuy = false;
        })
      }

    } else {
      //console.log('notlisted')
      this.isLoadingBuy = false;
      this.notListed = true;
    }
  }

  async executeClaim(claim, contractMerkleInstance, stage) {
    if (claim !== undefined) {
      this.notListed = false;
      await contractMerkleInstance.methods.buy(claim.index, claim.account, claim.proof, stage).send({
        ...this.contractsService.additionalParameters(),
        from: this.wallet
      }).then((receipt) => {
        //console.log(receipt);
        this.isLoadingBuy = false;
        this.refresh();
        alert("You've purchased your " + this.salesInternal[stage].name + "! It will be airdrop in the next 24 hours to your wallet.");
        analytics.track('ArmourSale', { section: 'trainerHub', value: this.wallet, status: 'completed', paymentMethod: this.paymentMethod })
      }).catch((err) => {
        ////console.log(err, 'err');
        this.toastService.genericError();;
        this.isLoadingBuy = false;
      });
    } else {
      //console.log('notlisted')
      this.isLoadingBuy = false;
      this.notListed = true;
    }
  }

  /*showModalConnect() {
    console.log('connect')
    this.appComponent.contractService.mount().then((data) => {
      console.log('data')
      console.log(data)
      if (data !== 'nomask' && data !== 'denied_access' && data !== 'wrong_network') {
        //console.log("quauauau")
        this.noWallet = false;
        this.getAccounts().then(() => { });
      } else {
        console.log('wut')
        if (data == "nomask") {
          this.noWallet = true;
          this.connection_text = "No wallet"
        } else if (data == "denied_access") {
          this.noWallet = true;
          this.connection_text = "Grant access"
          //console.log("qua!=")
        } else {
          this.noWallet = true;
          this.connection_text = "Wrong Network"
        }
      }
    }, (error) => {
      console.log('cia')
    });
  }*/

  indexOfMax(arr) {
    if (arr.length === 0) {
      return -1;
    }

    var max = arr[0];
    var maxIndex = 0;

    for (var i = 1; i < arr.length; i++) {
      if (arr[i] > max) {
        maxIndex = i;
        max = arr[i];
      }
    }

    return maxIndex;
  }

  closeShare() {
    this.showShare = false;
    this.collectedKryptomon = false;
  }

  claimFreeCosmetic(){
    let post = {
      walletId: this.userService._userInfoData.recordedWallet
    }

    this.http.post("https://api.kryptomon.co/babydoge/claim.php", post).subscribe((item:any)=>{
      if(item.status=='done'){
        this.toastService.add({
            severity: 'success',
            summary: 'shared.success',
            detail: 'Cosmetic claimed!',
          });
      }else{
        if(item.payload.indexOf('404')>=0){
          this.toastService.add(
          {
            severity: 'error',
            summary: 'errorMsg.generic',
            detail: 'Player not found, you need to log in game first! Come back once you have logged in World of Kogaea',
          }
        )
        }else{
          this.toastService.add(
          {
            severity: 'error',
            summary: 'errorMsg.generic',
            detail: item.payload,
          }
        )
        }
      }
    }, (err)=>{
      this.toastService.genericError()
    })
  }

  checkCosmetic(){
    let post = {
      playerID: this.userService._userInfoData.playfabID
    }
    this.http.post("https://api.kryptomon.co/babydoge/checkClaimed.php", post).subscribe((item:any)=>{
      console.log(item);
      if(item==null){
        this.canClaimCosmetic = true;
      }else{
        this.canClaimCosmetic = false;
      }
    })
  }

  /*connectDisconnectProvider() {
    if (this.connection_text == "Connected") {
      this.appComponent.contractService.disconnectProvider();
    } else {
      this.showModalConnect();
    }
  }*/

  startConfetti() {
    tsParticles.load("tsparticles", {
      fpsLimit: 60,
      particles: {
        number: {
          value: 0
        },
        color: {
          value: ["#00FFFC", "#FC00FF", "#fffc00"]
        },
        shape: {
          type: "confetti",
          options: {
            confetti: {
              type: ["circle", "square"]
            }
          }
        },
        opacity: {
          value: 1,
          animation: {
            enable: true,
            minimumValue: 0,
            speed: 2,
            startValue: "max",
            destroy: "min"
          }
        },
        size: {
          value: 7,
          random: {
            enable: true,
            minimumValue: 3
          }
        },
        links: {
          enable: false
        },
        life: {
          duration: {
            sync: true,
            value: 5
          },
          count: 1
        },
        move: {
          enable: true,
          gravity: {
            enable: true,
            acceleration: 20
          },
          speed: 20,
          decay: 0.1,
          direction: "none",
          random: false,
          straight: false,
          outModes: {
            default: "destroy",
            top: "none"
          }
        }
      },
      interactivity: {
        detectsOn: "window",
        events: {
          resize: true
        }
      },
      detectRetina: true,
      background: {
        color: "#232123"
      },
      emitters: {
        direction: "none",
        life: {
          count: 0,
          duration: 0.1,
          delay: 0.4
        },
        rate: {
          delay: 0.1,
          quantity: 100
        },
        size: {
          width: 0,
          height: 0
        }
      }
    });
  }

  gotoDashboard() {
    //this.router.navigate(['/']);
  }

  openPancake() {
    window.open("https://pancakeswap.finance/swap?outputCurrency=" + this.contractMBPurchaseToken._address + "&chainId=56", "_blank").focus()
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      console.log("clicked inside");
    } else {
      console.log("clicked outside");
      if (this.showOnramper) this.closeOnramper();
    }
  }

}

const BUY_METHODS = (itemData: ICompanyItemsResponse): IDropdownButtonItem[] => {
  let template = [
    {
      id: 'candyPrice',
      label: 'shared.buyInCandy',
      pic: currencyImgPath()[eCurrencies.CANDIES]
    },
    {
      id: 'KMON',

      label: 'Buy with KMON',

      pic: currencyImgPath()[eCurrencies.KMON]
    },
    {
      id: 'BabyDoge',

      label: 'Buy with BabyDoge',

      pic: currencyImgPath()[eCurrencies.BabyDoge]
    },
    {
      id: 'USDT',

      label: 'Buy with USDT',

      pic: currencyImgPath()[eCurrencies.USDT]
    },
    {
      id: 'KMONToken',

      label: 'Buy with KMON',

      pic: currencyImgPath()[eCurrencies.KMON]
    },
    {
      id: 'USD',
      label: 'Buy with Credit Card',
      pic: currencyImgPath()[eCurrencies.CreditCard]

    },
    {
      id: 'KmonCoin',

      label: 'Buy with KMON',

      pic: currencyImgPath()[eCurrencies.KMON]
    }
  ];
  let result: IDropdownButtonItem[] = [];
  if (itemData.candyPrice) result.push(template.filter(i => i.id == 'candyPrice')[0]);
  itemData.prices.forEach(p => {
    let aCurrency = template.filter(i => i.id == p.currency.symbol);
    if (aCurrency.length) result.push(aCurrency[0]);
  })
  return result;

}


